import React, { useState } from "react";
import Swal from "sweetalert2";
import Collapse from "react-bootstrap/Collapse";
import useAsync from "../../../hooks/useAsync";
import LocationServices from "../../../services/LocationServices";
import AdminServices from "../../../services/AdminServices";
import { Modal } from "react-bootstrap";

const UserAddModel = ({ show, handleClose, test }) => {
  const open2 = true;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNo, setMobileNo] = useState('');
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [stores, setSelectedStores] = useState([]); // Changed to array for multiple stores
  const [error, setError] = useState("");

  // Fetch stores for the store location dropdown
  const { data } = useAsync(LocationServices.getStore);

  // Handle store selection (multiple stores)
  const handleStoreChange = (e) => {
    const selectedOptions = Array.from(
      e.target.selectedOptions,
      (option) => option.value
    );

    if (
      selectedRole === "MachineOperator" &&
      selectedOptions.length > 1
    ) {

      Swal.fire({
        icon: "warning",
        title: "Only One Store Allowed",
        text: "Only one store is allowed for Machine Operator role. Please remove the old store before adding a new one."
      });

      return;
    }

    setSelectedStores(selectedOptions);

  };

  const isValidEmail = (email) => {
    // Basic email validation regex pattern
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const isValidMobile = (mobile) => {
    const regex = /^[6-9]\d{9}$/;
    return regex.test(mobile);
  };

  const resetForm = () => {
    setName("");
    setEmail("");
    setMobileNo("");
    setPassword("");
    setConfirmPassword("");
    setSelectedRole("");
    setSelectedStores([]);
    setError("");
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for empty fields
    if (!name || !email || !mobileNo || !password || !confirmPassword || !selectedRole || stores.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "All fields are required!",
      });
      return;
    }

    // Check if email is valid
    if (!isValidEmail(email)) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please enter a valid email address!",
      });
      return;
    }

    // Check if mobile is valid
    if (!isValidMobile(mobileNo)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Mobile Number",
        text: "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.",
      });
      return;
    }



    // Check if passwords match
    if (password !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Passwords do not match!",
      });
      return;
    }

    if (
      selectedRole === "MachineOperator" &&
      stores.length > 1
    ) {

      return Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Only one store is allowed for Machine Operator role."
      });

    }

    try {
      const newUser = {
        name,
        email,
        mobileNo: Number(mobileNo),
        password,
        role: selectedRole,
        stores,  // Send the array of selected stores
        passwordConfirm: confirmPassword,
      };

      const response = await AdminServices.signUp(newUser);

      if (response.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Good job!",
          text: "User Added Successfully!",
        });
        // Reset form fields
        setName("");
        setEmail("");
        setPassword("");
        setConfirmPassword("");
        setSelectedRole("");
        setSelectedStores([]);  // Clear selected stores
        handleClose();
        setError("");
      } else {
        setError("Failed to add user");
      }
    } catch (error) {
      //alert(error.response?.data?.message)
      //setError(error?.response?.data?.message || "An error occurred");
      Swal.fire('Error', error.response?.data?.message, 'error');
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        className="fade"
      >
        <div className="row">
          <div className="col-xl-12">
            <div className="filter cm-content-box box-primary mt-1">
              <Modal.Body>
                <Collapse in={open2}>
                  <div className="cm-content-body form excerpt">
                    <div className="card-body">
                      <div className="table-responsive">
                        <div id="content_wrapper" className="dataTables_wrapper no-footer">
                          <Modal.Header closeButton>
                            <Modal.Title>
                              <i className="fa fa-user-plus me-2"></i>
                              Add New User

                            </Modal.Title>
                          </Modal.Header>
                          <form onSubmit={handleSubmit}>
                            <div className="row">
                              <div className="form-group mb-3 col-md-6">
                                <label>Full Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={name}
                                  onChange={(e) => setName(e.target.value)}
                                  placeholder="Full Name"
                                />
                              </div>
                              <div className="form-group mb-3 col-md-6">
                                <label>Email</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  placeholder="Email"
                                />
                              </div>
                              <div className="form-group mb-3 col-md-6">
                                <label>Password</label>
                                <input
                                  type="password"
                                  className="form-control"
                                  value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  placeholder="Password"
                                />
                              </div>
                              <div className="form-group mb-3 col-md-6">
                                <label>Confirm Password</label>
                                <input
                                  type="password"
                                  className="form-control"
                                  value={confirmPassword}
                                  onChange={(e) => setConfirmPassword(e.target.value)}
                                  placeholder="Confirm Password"
                                />
                              </div>
                              <div className="form-group mb-3 col-md-12">
                                <label>Mobile Number</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  value={mobileNo}
                                  onChange={(e) => setMobileNo(e.target.value)}
                                  placeholder="Mobile No."
                                />
                              </div>
                            </div>

                            <div className="row">
                              <div className="form-group mb-3 col-md-6">
                                <label>Assign Role</label>
                                <select
                                  className="form-control"
                                  value={selectedRole}
                                  onChange={(e) => setSelectedRole(e.target.value)}
                                >
                                  <option value="">Choose...</option>
                                  <option value="admin">Admin</option>
                                  <option value="storeKeeper">Store Keeper</option>
                                  <option value="MachineOperator">Machine Operator</option>
                                  <option value="pomaker">Po Maker</option>
                                  <option value="pochecker">Po Checker</option>
                                  <option value="billing">Billing</option>
                                  <option value="accounts">Accounts</option>

                                </select>
                              </div>

                              {/* Multi-select for Stores */}
                              <div className="form-group mb-3 col-md-6">
                                <label>Location</label>
                                <select
                                  className="form-control"
                                  multiple
                                  value={stores}
                                  onChange={handleStoreChange}
                                  onMouseDown={(e) => {
                                    if (!selectedRole) {
                                      e.preventDefault(); // Prevent dropdown from opening
                                      Swal.fire({
                                        icon: "warning",
                                        title: "Role Required",
                                        text: "Please select a role for the user."
                                      });
                                    }
                                  }}

                                >
                                  <option value="">Select Store</option>
                                  {data?.data?.data?.map((store, index) => (
                                    <option key={index} value={store._id}>
                                      {`${store.name}, ${store.location}`}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            {/* Error Message */}
                            {error && <p style={{ color: "red" }}>{error}</p>}


                            <button type="submit" className="btn btn-primary me-2">
                              Submit
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => {
                                setName("");
                                setEmail("");
                                setPassword("");
                                setConfirmPassword("");
                                setSelectedRole("");
                                setSelectedStores([]); // Clear selected stores
                                setError("");
                                resetForm();
                                handleClose();
                              }}
                            >
                              Cancel
                            </button>
                          </form>
                          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Modal.Body>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UserAddModel;
